
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $cXtTj = parcelRequire("cXtTj");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $8f621f3867006eb3$export$e8ff3768de40dcb2 = ()=>(parcelRequire("jJ6xM"));



var $hyOW3 = parcelRequire("hyOW3");


var $fDOrD = parcelRequire("fDOrD");


var $jv1SC = parcelRequire("jv1SC");

const $6e95e9a207754122$var$PRELOADER_SMART_CARD = 'smart-card';
const $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $6e95e9a207754122$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $6e95e9a207754122$var$ALL_PRELOADERS = [
    $6e95e9a207754122$var$PRELOADER_SMART_CARD,
    $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST,
    $6e95e9a207754122$var$PRELOADER_SMART_CREATION,
    $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG
];
let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$var$isPreloaderName(preloader) {
    return $6e95e9a207754122$var$ALL_PRELOADERS.includes(preloader);
}
function $6e95e9a207754122$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($6e95e9a207754122$var$isPreloaderName));
}
function $6e95e9a207754122$var$preloadSmartCard() {
    (0, $8f621f3867006eb3$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadAutoSuggest() {
    (0, $hyOW3.importAutoSuggest)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadSmartCreationWrapper() {
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadFeedbackFlag() {
    (0, $fDOrD.importFeedbackFlag)().catch(()=>{});
}
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $6e95e9a207754122$var$getEnabledPreloaders((0, $cXtTj.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CARD)) $6e95e9a207754122$var$preloadSmartCard();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST)) $6e95e9a207754122$var$preloadAutoSuggest();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CREATION)) $6e95e9a207754122$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG)) $6e95e9a207754122$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("jJ6xM", function(module, exports) {

let $e5c74bc8d0c2fedc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5c74bc8d0c2fedc$var$load("iNoxQ"),
    $e5c74bc8d0c2fedc$var$load("lOm4J"),
    $e5c74bc8d0c2fedc$var$load("dBHUb"),
    $e5c74bc8d0c2fedc$var$load("5Rx9J"),
    $e5c74bc8d0c2fedc$var$load("eRhBr"),
    $e5c74bc8d0c2fedc$var$load("6HpsR"),
    $e5c74bc8d0c2fedc$var$load("N3oqb"),
    $e5c74bc8d0c2fedc$var$load("hZ2FX"),
    $e5c74bc8d0c2fedc$var$load("9ZFGK"),
    $e5c74bc8d0c2fedc$var$load("2hLAI"),
    $e5c74bc8d0c2fedc$var$load("dCilB"),
    $e5c74bc8d0c2fedc$var$load("h1yOv"),
    $e5c74bc8d0c2fedc$var$load("1T8H1"),
    $e5c74bc8d0c2fedc$var$load("fyKFO"),
    $e5c74bc8d0c2fedc$var$load("d9sg7"),
    $e5c74bc8d0c2fedc$var$load("l0N35"),
    $e5c74bc8d0c2fedc$var$load("bU9L5"),
    $e5c74bc8d0c2fedc$var$load("fuOfV"),
    $e5c74bc8d0c2fedc$var$load("iZR3N"),
    $e5c74bc8d0c2fedc$var$load("4zz48"),
    $e5c74bc8d0c2fedc$var$load("jXM1T"),
    $e5c74bc8d0c2fedc$var$load("cvcNg"),
    $e5c74bc8d0c2fedc$var$load("jw3lv"),
    $e5c74bc8d0c2fedc$var$load("7rqWx"),
    $e5c74bc8d0c2fedc$var$load("aIze1"),
    $e5c74bc8d0c2fedc$var$load("il8bj"),
    $e5c74bc8d0c2fedc$var$load("4N1MY"),
    $e5c74bc8d0c2fedc$var$load("kG5Ju"),
    $e5c74bc8d0c2fedc$var$load("39XCn"),
    $e5c74bc8d0c2fedc$var$load("3Cky6"),
    $e5c74bc8d0c2fedc$var$load("jL1Ke"),
    $e5c74bc8d0c2fedc$var$load("5MQ0D"),
    $e5c74bc8d0c2fedc$var$load("aFLSJ"),
    $e5c74bc8d0c2fedc$var$load("6fJCf"),
    $e5c74bc8d0c2fedc$var$load("duEFL"),
    $e5c74bc8d0c2fedc$var$load("6wr18"),
    $e5c74bc8d0c2fedc$var$load("1pJPT"),
    $e5c74bc8d0c2fedc$var$load("8zMmc"),
    $e5c74bc8d0c2fedc$var$load("4x9Jx"),
    $e5c74bc8d0c2fedc$var$load("7EorR"),
    $e5c74bc8d0c2fedc$var$load("ffEVr"),
    $e5c74bc8d0c2fedc$var$load("2EIkU"),
    $e5c74bc8d0c2fedc$var$load("Wowvf"),
    $e5c74bc8d0c2fedc$var$load("hhss7"),
    $e5c74bc8d0c2fedc$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("hyOW3", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("5KumS"));
}
module.exports["importAutoSuggest"] = $04373e772f510be6$export$5531859f311f2932;

});

parcelRegister("5KumS", function(module, exports) {

let $42f8ce15b21930cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $42f8ce15b21930cd$var$load("dBHUb"),
    $42f8ce15b21930cd$var$load("5Rx9J"),
    $42f8ce15b21930cd$var$load("6wr18"),
    $42f8ce15b21930cd$var$load("ffEVr"),
    $42f8ce15b21930cd$var$load("eCXJR"),
    $42f8ce15b21930cd$var$load("1VTX2"),
    $42f8ce15b21930cd$var$load("2EIkU"),
    $42f8ce15b21930cd$var$load("eRhBr"),
    $42f8ce15b21930cd$var$load("hZ2FX"),
    $42f8ce15b21930cd$var$load("hhss7"),
    $42f8ce15b21930cd$var$load("kT6dz"),
    $42f8ce15b21930cd$var$load("aAWLw"),
    $42f8ce15b21930cd$var$load("lRgOm")
]).then(()=>parcelRequire('79mXg'));

});

parcelRegister("fDOrD", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));
module.exports["importFeedbackFlag"] = $e837e744ff2037be$export$1eafe3a5df99a0a0;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("44wwu"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("44wwu", function(module, exports) {

let $2f70c38454c6599f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2f70c38454c6599f$var$load("4ZKBo"),
    $2f70c38454c6599f$var$load("3WmaY"),
    $2f70c38454c6599f$var$load("7gL7H"),
    $2f70c38454c6599f$var$load("7TnhR"),
    $2f70c38454c6599f$var$load("hUbK8"),
    $2f70c38454c6599f$var$load("68hpv"),
    $2f70c38454c6599f$var$load("1r4R9"),
    $2f70c38454c6599f$var$load("bx5S2"),
    $2f70c38454c6599f$var$load("7fsAO"),
    $2f70c38454c6599f$var$load("knuqf"),
    $2f70c38454c6599f$var$load("ipIDQ"),
    $2f70c38454c6599f$var$load("agv3Q"),
    $2f70c38454c6599f$var$load("garBx"),
    $2f70c38454c6599f$var$load("eyY0h"),
    $2f70c38454c6599f$var$load("5HweM"),
    $2f70c38454c6599f$var$load("l4MHo"),
    $2f70c38454c6599f$var$load("k97np"),
    $2f70c38454c6599f$var$load("by6h6"),
    $2f70c38454c6599f$var$load("j3345"),
    $2f70c38454c6599f$var$load("2J2X1"),
    $2f70c38454c6599f$var$load("7xLM7"),
    $2f70c38454c6599f$var$load("Mjfig"),
    $2f70c38454c6599f$var$load("e7Dyr"),
    $2f70c38454c6599f$var$load("cPAXo"),
    $2f70c38454c6599f$var$load("44j0l"),
    $2f70c38454c6599f$var$load("6aezV"),
    $2f70c38454c6599f$var$load("huHiR"),
    $2f70c38454c6599f$var$load("46GUH"),
    $2f70c38454c6599f$var$load("dxcsb"),
    $2f70c38454c6599f$var$load("gbejv"),
    $2f70c38454c6599f$var$load("GD9EA"),
    $2f70c38454c6599f$var$load("2hLAI"),
    $2f70c38454c6599f$var$load("dCilB"),
    $2f70c38454c6599f$var$load("1T8H1"),
    $2f70c38454c6599f$var$load("fyKFO"),
    $2f70c38454c6599f$var$load("d9sg7"),
    $2f70c38454c6599f$var$load("l0N35"),
    $2f70c38454c6599f$var$load("iNoxQ"),
    $2f70c38454c6599f$var$load("lOm4J"),
    $2f70c38454c6599f$var$load("9LVeR"),
    $2f70c38454c6599f$var$load("8exG0"),
    $2f70c38454c6599f$var$load("gnocL"),
    $2f70c38454c6599f$var$load("kT6dz"),
    $2f70c38454c6599f$var$load("dBHUb"),
    $2f70c38454c6599f$var$load("5Rx9J"),
    $2f70c38454c6599f$var$load("6wr18"),
    $2f70c38454c6599f$var$load("av7K3"),
    $2f70c38454c6599f$var$load("hZVEi"),
    $2f70c38454c6599f$var$load("fcsnw"),
    $2f70c38454c6599f$var$load("ffEVr"),
    $2f70c38454c6599f$var$load("eCXJR"),
    $2f70c38454c6599f$var$load("1VTX2"),
    $2f70c38454c6599f$var$load("ddvkk"),
    $2f70c38454c6599f$var$load("3upHR"),
    $2f70c38454c6599f$var$load("hhss7"),
    $2f70c38454c6599f$var$load("Wowvf"),
    $2f70c38454c6599f$var$load("eRhBr"),
    $2f70c38454c6599f$var$load("hZ2FX"),
    $2f70c38454c6599f$var$load("cKDij"),
    $2f70c38454c6599f$var$load("7EorR"),
    $2f70c38454c6599f$var$load("ce05o"),
    $2f70c38454c6599f$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.ab6f455c.js.map
